<template>
	<div class="error_wrap">
		<article>
			<div class="error_inner">
				<p>ERROR</p>
				<span>{{ errorMessage }}<br />Please contact support@bwisesoft.com</span>
				<!-- <a href="javascript:;" class="normal_bt error_home_bt" onClick="history.go(-2);">To Main page</a> -->
				<a href="javascript:;" class="normal_bt error_home_bt" @click="goHome()">To Main page</a>
			</div>
		</article>
	</div>
</template>

<script>
require('@/assets/css/error.css?ver=1.0');

export default {
	data: function() {
		return {
			errorMessage: '',
		};
	},
	methods: {
		goHome() {
			this.$router.push('/');
		},
	},
	created() {
		this.errorMessage = this.$route.params.message;
	},
};
</script>

<style></style>
